<template>
    <div class="breadcrumb" :class="{'text-dark' : textDark,'visited': visited }">
        <span
            v-for="(word, wordIndex) in words"
            class="breadcrumb__word"
            :class="{'last':wordIndex==words.length-1}"
        >
            <span>
                <a v-if="word === 'home'" :href="$route('app.home')" ><span>{{ capitalize(word) }}</span></a>
                <span v-else >{{ capitalize(word) }}</span>
            </span><!--
            --><svg v-if="wordIndex!=words.length-1" width="14" height="8" xmlns="http://www.w3.org/2000/svg">
                    <path :fill="svgColor()" d="M.293.293a1 1 0 0 1 1.414 0L7 5.586 12.293.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z"/>
                </svg>
        </span>
    </div>
</template>

<script>
export default {
    name: "Breadcrumb",
    data() {
        return {
            visited: localStorage.getItem('visited')
        }
    },
    props:{
        words: {type:Array,required:true},
        textDark : {
            default: false,
            type: Boolean
        }
    },
    methods: {
        svgColor() {
            if (this.textDark){
                return '#000'
            }
            return '#fff'
        },
        capitalize(word) {
            return _.capitalize(word)
        }
    },
}
</script>

<style scoped>

</style>
